export default __webpack_public_path__ + "static/media/comicslogo.59282ff5.PNG";